import { render, staticRenderFns } from "./FormChoice.vue?vue&type=template&id=1cb690ee&scoped=true"
import script from "./FormChoice.vue?vue&type=script&lang=js"
export * from "./FormChoice.vue?vue&type=script&lang=js"
import style0 from "./FormChoice.vue?vue&type=style&index=0&id=1cb690ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb690ee",
  null
  
)

export default component.exports